export interface ZendeskSsoFormParams {
  jwt: string
  postUrl: string
  locale: string
  returnTo: string
}

// TODO (MEM-341, plan Section E): this Zendesk SSO bounce flow — this file plus
// the HelpCenterLogin/Logout containers and the /services/login|logout routes —
// is slated for removal once Zendesk no longer redirects members here for JWT
// SSO. `getLocalizedZendeskLink` moved here from the deleted HelpCenterClient as
// its only remaining consumer; it goes away with the rest of this flow.
export function getLocalizedZendeskLink(link: string, zendeskLocale: string): string {
  const linkWithoutLocale = link.replace(/\/en-us/i, "")
  return linkWithoutLocale.replace("hc", `hc/${zendeskLocale}`)
}

function buildHiddenZendeskSsoForm({ jwt, postUrl, locale, returnTo }: ZendeskSsoFormParams): HTMLFormElement {
  const localizedReturnTo = getLocalizedZendeskLink(returnTo, locale)

  const form = document.createElement("form")
  form.method = "POST"
  form.action = postUrl
  form.style.display = "none"

  const appendInput = (name: string, value: string) => {
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = name
    input.value = value
    form.appendChild(input)
  }

  appendInput("jwt", jwt)
  appendInput("return_to", localizedReturnTo)

  return form
}

/**
 * Submits a hidden form POST to Zendesk's `/access/jwt` endpoint.
 *
 * Zendesk requires a real form submission so that cookies are set on the browser, and cross-origin policy would block
 * an AJAX POST to the Zendesk domain.
 *
 * See: https://support.zendesk.com/hc/en-us/articles/4408845838874-Enabling-JWT-single-sign-on.
 */
export function submitZendeskSsoForm(params: ZendeskSsoFormParams): void {
  const form = buildHiddenZendeskSsoForm(params)
  document.body.appendChild(form)
  form.submit()
}
